import {
  MessageBox,
  Button
} from 'element-ui'

const setMessageBoxButton = function (MessageBoxDefaults) {
  const {
    confirmButtonText,
    cancelButtonText
  } = MessageBoxDefaults

  const MessageBoxConfirmButton = Button.config[confirmButtonText.replace(/\s/g,"")] || Button.config.default
  const MessageBoxCancelButton = Button.config[cancelButtonText.replace(/\s/g,"")] || Button.config.default

  if (MessageBoxConfirmButton) {
    if (MessageBoxConfirmButton.type) {
      MessageBoxDefaults.confirmButtonClass += ` el-button--${MessageBoxConfirmButton.type}`
    }

    if (MessageBoxConfirmButton.plain) {
      MessageBoxDefaults.confirmButtonClass += ' is-plain'
    }
  }

  if (MessageBoxCancelButton) {
    if (MessageBoxCancelButton.type) {
      MessageBoxDefaults.cancelButtonClass += ` el-button--${MessageBoxCancelButton.type}`
    }

    if (MessageBoxCancelButton.plain) {
      MessageBoxDefaults.cancelButtonClass += ' is-plain'
    }
  }
}

MessageBox.setDefaults = function (defaults = {}) {
  MessageBox.defaults = Object.assign({}, MessageBox.defaults, defaults)

  setMessageBoxButton(MessageBox.defaults)
}

MessageBox.setDefaults({
  confirmButtonClass: '',
  cancelButtonClass: '',
  confirmButtonText: '确认',
  cancelButtonText: '取消'
})
